import { useState, useCallback, useEffect } from 'react';
import { message } from 'antd';
import vendorEvalApi, { F10H, F10H1, F10H2, F10H3 } from '../../../services/vendorEvalApi';

type Mode = 'browse' | 'add' | 'edit';

const defaultCredit = (): Partial<F10H3> => ({
  f10h3_11: '', f10h3_13: '', f10h3_131: '', f10h3_14: '', f10h3_141: '',
  f10h3_16: '', f10h3_161: 0, f10h3_162: '', f10h3_17: '', f10h3_171: 0, f10h3_172: '',
  f10h3_21: 0, f10h3_22: 0, f10h3_25: '',
  f10h3_26: 0, f10h3_27: 0,
  f10h3_31: 0, f10h3_32: 0, f10h3_35: '',
  f10h3_36: 0, f10h3_37: 0,
});

const defaultAddresses = (): Partial<F10H1>[] => [
  { f10h1_02: 1, f10h1_11: '公司', f10h1_12: '', f10h1_13: '', f10h1_14: '' },
  { f10h1_02: 2, f10h1_11: '發票', f10h1_12: '', f10h1_13: '', f10h1_14: '' },
  { f10h1_02: 3, f10h1_11: '工廠', f10h1_12: '', f10h1_13: '', f10h1_14: '' },
];

const FIXED_CONTACTS = ['負責人', '業務', '採購', '會計出納'];

const defaultContacts = (): Partial<F10H2>[] => [
  { f10h2_02: '', f10h2_11: '負責人', f10h2_12: '', f10h2_13: '', f10h2_14: '', f10h2_15: '', f103_01: '', f103_12: '', f103_14: '', f103_21: '', f103_22: '' },
  { f10h2_02: '', f10h2_11: '業務', f10h2_12: '', f10h2_13: '', f10h2_14: '', f10h2_15: '', f103_01: '', f103_12: '', f103_14: '', f103_21: '', f103_22: '' },
  { f10h2_02: '', f10h2_11: '採購', f10h2_12: '', f10h2_13: '', f10h2_14: '', f10h2_15: '', f103_01: '', f103_12: '', f103_14: '', f103_21: '', f103_22: '' },
  { f10h2_02: '', f10h2_11: '會計出納', f10h2_12: '', f10h2_13: '', f10h2_14: '', f10h2_15: '', f103_01: '', f103_12: '', f103_14: '', f103_21: '', f103_22: '' },
];

export { FIXED_CONTACTS };

export function useVendorEvalForm() {
  const [mode, setMode] = useState<Mode>('browse');
  const [records, setRecords] = useState<F10H[]>([]);
  const [currentIdx, setCurrentIdx] = useState(0);
  const [loading, setLoading] = useState(false);

  // Master fields
  const [f10h_01, setF10h01] = useState('');
  const [f10h_02, setF10h02] = useState('');
  const [f10h_03, setF10h03] = useState<string | null>(null);
  const [f10h_10, setF10h10] = useState('');
  const [f10h_11, setF10h11] = useState('');
  const [f10h_12, setF10h12] = useState('');
  const [f10h_13, setF10h13] = useState('');
  const [f10h_14, setF10h14] = useState('TWN');
  const [f10h_17, setF10h17] = useState(''); // 資本額
  const [f10h_18, setF10h18] = useState(''); // 營業項目
  const [f10h_20, setF10h20] = useState(''); // 傳真
  const [f10h_21, setF10h21] = useState(''); // 統一編號
  const [f10h_22, setF10h22] = useState(''); // 公司電子郵件
  const [f10h_23, setF10h23] = useState(''); // 網站
  const [f10h_24, setF10h24] = useState(''); // 備註/摘要
  const [f10h_30, setF10h30] = useState('');
  const [f10h_34, setF10h34] = useState('');
  const [f10h_41, setF10h41] = useState('');
  const [f10h_411, setF10h411] = useState(''); // 廠商特性代碼
  const [f10h_42, setF10h42] = useState('');
  const [f10h_421, setF10h421] = useState(''); // 機器設備代碼
  const [f10h_43, setF10h43] = useState('');
  const [f10h_431, setF10h431] = useState(''); // 產能預估代碼
  const [f10h_44, setF10h44] = useState('');
  const [f10h_441, setF10h441] = useState(''); // 樣品評核代碼
  const [f10h_45, setF10h45] = useState('');
  const [f10h_451, setF10h451] = useState(''); // 其他代碼
  const [f10h_46, setF10h46] = useState(false); // ISO 9000
  const [f10h_47, setF10h47] = useState(false); // 專利權
  const [f10h_48, setF10h48] = useState(false); // 獨占性
  const [f10h_49, setF10h49] = useState(false); // 上市上櫃
  const [f10h_51, setF10h51] = useState('');
  const [f10h_80, setF10h80] = useState('');
  const [f10h_802, setF10h802] = useState(''); // 部門核准說明
  const [f10h_81, setF10h81] = useState('');
  const [f10h_812, setF10h812] = useState(''); // 研發核准說明
  const [f10h_82, setF10h82] = useState('');
  const [f10h_822, setF10h822] = useState(''); // 總經理核准說明
  const [f10h_91, setF10h91] = useState('');
  const [f10h_92, setF10h92] = useState<string | null>(null);

  // Sub-table fields
  const [addresses, setAddresses] = useState<Partial<F10H1>[]>(defaultAddresses());
  const [contacts, setContacts] = useState<Partial<F10H2>[]>(defaultContacts());
  const [credit, setCredit] = useState<Partial<F10H3>>(defaultCredit());

  const loadRecords = useCallback(async () => {
    setLoading(true);
    try {
      const res = await vendorEvalApi.list(1, 500);
      setRecords(res.data || []);
      if ((res.data || []).length > 0) {
        setCurrentIdx(0);
      }
    } catch {
      message.error('載入資料失敗');
    } finally {
      setLoading(false);
    }
  }, []);

  const syncFields = useCallback((rec: F10H) => {
    setF10h01(rec.f10h_01 || '');
    setF10h02(rec.f10h_02 || '');
    setF10h03(rec.f10h_03);
    setF10h10(rec.f10h_10 || '');
    setF10h11(rec.f10h_11 || '');
    setF10h12(rec.f10h_12 || '');
    setF10h13(rec.f10h_13 || '');
    setF10h14(rec.f10h_14 || '');
    setF10h17(rec.f10h_17 || '');
    setF10h18(rec.f10h_18 || '');
    setF10h20(rec.f10h_20 || '');
    setF10h21(rec.f10h_21 || '');
    setF10h22(rec.f10h_22 || '');
    setF10h23(rec.f10h_23 || '');
    setF10h24(rec.f10h_24 || '');
    setF10h30(rec.f10h_30 || '');
    setF10h34(rec.f10h_34 || '');
    setF10h41(rec.f10h_41 || '');
    setF10h411(rec.f10h_411 || '');
    setF10h42(rec.f10h_42 || '');
    setF10h421(rec.f10h_421 || '');
    setF10h43(rec.f10h_43 || '');
    setF10h431(rec.f10h_431 || '');
    setF10h44(rec.f10h_44 || '');
    setF10h441(rec.f10h_441 || '');
    setF10h45(rec.f10h_45 || '');
    setF10h451(rec.f10h_451 || '');
    setF10h46(!!rec.f10h_46);
    setF10h47(!!rec.f10h_47);
    setF10h48(!!rec.f10h_48);
    setF10h49(!!rec.f10h_49);
    setF10h51(rec.f10h_51 || '');
    setF10h80(rec.f10h_80 || '');
    setF10h802(rec.f10h_802 || '');
    setF10h81(rec.f10h_81 || '');
    setF10h812(rec.f10h_812 || '');
    setF10h82(rec.f10h_82 || '');
    setF10h822(rec.f10h_822 || '');
    setF10h91(rec.f10h_91 || '');
    setF10h92(rec.f10h_92);
    setAddresses(rec.addresses?.length > 0 ? rec.addresses : defaultAddresses());
    setContacts(rec.contacts?.length > 0 ? rec.contacts : defaultContacts());
    setCredit(rec.credit || defaultCredit());
  }, []);

  useEffect(() => {
    loadRecords();
  }, [loadRecords]);

  useEffect(() => {
    if (records.length > 0 && currentIdx >= 0 && currentIdx < records.length) {
      syncFields(records[currentIdx]);
    }
  }, [records, currentIdx, syncFields]);

  // Navigation
  const navFirst = useCallback(() => setCurrentIdx(0), []);
  const navPrev = useCallback(() => setCurrentIdx((i) => Math.max(0, i - 1)), []);
  const navNext = useCallback(() => setCurrentIdx((i) => Math.min(records.length - 1, i + 1)), [records.length]);
  const navLast = useCallback(() => setCurrentIdx(records.length - 1), [records.length]);

  const startAdd = useCallback(() => {
    setMode('add');
    setF10h01(''); setF10h02('D'); setF10h03(null);
    setF10h10(''); setF10h11(''); setF10h12(''); setF10h13('');
    setF10h14('TWN');
    setF10h17(''); setF10h18('');
    setF10h20(''); setF10h21(''); setF10h22(''); setF10h23(''); setF10h24('');
    setF10h30(''); setF10h34(''); setF10h51('');
    setF10h41(''); setF10h411(''); setF10h42(''); setF10h421('');
    setF10h43(''); setF10h431(''); setF10h44(''); setF10h441('');
    setF10h45(''); setF10h451('');
    setF10h46(false); setF10h47(false); setF10h48(false); setF10h49(false);
    setF10h80(''); setF10h802('');
    setF10h81(''); setF10h812('');
    setF10h82(''); setF10h822('');
    setF10h91(''); setF10h92(null);
    setAddresses(defaultAddresses());
    setContacts(defaultContacts());
    setCredit(defaultCredit());
  }, []);

  const startEdit = useCallback(() => {
    setMode('edit');
  }, []);

  const cancel = useCallback(() => {
    setMode('browse');
    if (records.length > 0) {
      syncFields(records[currentIdx]);
    }
  }, [records, currentIdx, syncFields]);

  const buildPayload = useCallback((): Partial<F10H> => ({
    f10h_01: f10h_01.trim(),
    f10h_02: f10h_02.trim(),
    f10h_10: f10h_10.trim(),
    f10h_11: f10h_11.trim(),
    f10h_12: f10h_12.trim(),
    f10h_13: f10h_13.trim(),
    f10h_14: f10h_14.trim(),
    f10h_17: f10h_17.trim(),
    f10h_18: f10h_18.trim(),
    f10h_20: f10h_20.trim(),
    f10h_21: f10h_21.trim(),
    f10h_22: f10h_22.trim(),
    f10h_23: f10h_23.trim(),
    f10h_24: f10h_24,
    f10h_30: f10h_30.trim(),
    f10h_34: f10h_34.trim(),
    f10h_41: f10h_41,
    f10h_411: f10h_411.trim(),
    f10h_42: f10h_42,
    f10h_421: f10h_421.trim(),
    f10h_43: f10h_43,
    f10h_431: f10h_431.trim(),
    f10h_44: f10h_44,
    f10h_441: f10h_441.trim(),
    f10h_45: f10h_45,
    f10h_451: f10h_451.trim(),
    f10h_46: f10h_46,
    f10h_47: f10h_47,
    f10h_48: f10h_48,
    f10h_49: f10h_49,
    f10h_51: f10h_51.trim(),
    addresses: addresses as F10H1[],
    contacts: contacts as F10H2[],
    credit: credit as F10H3,
  }), [f10h_01, f10h_02, f10h_10, f10h_11, f10h_12, f10h_13, f10h_14,
    f10h_17, f10h_18, f10h_20, f10h_21, f10h_22, f10h_23, f10h_24,
    f10h_30, f10h_34,
    f10h_41, f10h_411, f10h_42, f10h_421, f10h_43, f10h_431,
    f10h_44, f10h_441, f10h_45, f10h_451,
    f10h_46, f10h_47, f10h_48, f10h_49, f10h_51,
    addresses, contacts, credit]);

  const save = useCallback(async () => {
    setLoading(true);
    try {
      const payload = buildPayload();
      if (mode === 'add') {
        await vendorEvalApi.create(payload);
        message.success('新增成功');
      } else {
        await vendorEvalApi.update(f10h_01, payload);
        message.success('儲存成功');
      }
      setMode('browse');
      await loadRecords();
    } catch (err: any) {
      if (err?.response?.status === 422) {
        const errors = err.response.data?.errors;
        if (Array.isArray(errors) && errors.length > 0) {
          message.error(errors[0].message);
        }
      } else {
        message.error('儲存失敗');
      }
    } finally {
      setLoading(false);
    }
  }, [mode, f10h_01, buildPayload, loadRecords]);

  const doDelete = useCallback(async () => {
    if (!f10h_01) return;
    setLoading(true);
    try {
      await vendorEvalApi.delete(f10h_01);
      message.success('刪除成功');
      await loadRecords();
    } catch {
      message.error('刪除失敗');
    } finally {
      setLoading(false);
    }
  }, [f10h_01, loadRecords]);

  const quickSearch = useCallback((keyword: string) => {
    const idx = records.findIndex((r) =>
      r.f10h_01.toUpperCase().includes(keyword.toUpperCase()) ||
      (r.f10h_11 || '').toUpperCase().includes(keyword.toUpperCase())
    );
    if (idx >= 0) {
      setCurrentIdx(idx);
    } else {
      message.warning('查無資料');
    }
  }, [records]);

  // Contact add/remove
  const addContact = useCallback(() => {
    setContacts(prev => [...prev, { f10h2_02: '', f10h2_11: '', f10h2_12: '', f10h2_13: '', f10h2_14: '', f10h2_15: '', f103_01: '', f103_12: '', f103_14: '', f103_21: '', f103_22: '' }]);
  }, []);

  const removeContact = useCallback((idx: number) => {
    setContacts(prev => prev.filter((_, i) => i !== idx));
  }, []);

  return {
    mode, loading, records, currentIdx,
    f10h_01, f10h_02, f10h_03, f10h_10, f10h_11, f10h_12, f10h_13,
    f10h_14, f10h_17, f10h_18,
    f10h_20, f10h_21, f10h_22, f10h_23, f10h_24, f10h_30,
    f10h_34,
    f10h_41, f10h_411, f10h_42, f10h_421, f10h_43, f10h_431,
    f10h_44, f10h_441, f10h_45, f10h_451,
    f10h_46, f10h_47, f10h_48, f10h_49,
    f10h_51,
    f10h_80, f10h_802, f10h_81, f10h_812, f10h_82, f10h_822,
    f10h_91, f10h_92,
    setF10h01, setF10h02, setF10h10, setF10h11, setF10h12, setF10h13,
    setF10h14, setF10h17, setF10h18,
    setF10h20, setF10h21, setF10h22, setF10h23, setF10h24,
    setF10h30, setF10h34,
    setF10h41, setF10h411, setF10h42, setF10h421,
    setF10h43, setF10h431, setF10h44, setF10h441,
    setF10h45, setF10h451,
    setF10h46, setF10h47, setF10h48, setF10h49,
    setF10h51,
    addresses, setAddresses, contacts, setContacts, credit, setCredit,
    addContact, removeContact,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save, doDelete,
    quickSearch,
    recordCount: records.length,
    recordPosition: records.length > 0 ? currentIdx + 1 : 0,
  };
}
